import { render } from "./Hibernation.vue?vue&type=template&id=aab74658"
import script from "./Hibernation.vue?vue&type=script&lang=js"
export * from "./Hibernation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__